export const MOVE_SHEET_PAGE_SIZE_DEFAUlT = 10;
export const MOVE_SHEET_INITIAL_PAGE = 1;

export enum MOVE_CUSTOM_SHEET {
  TRANSFORMED = 'transformado_',
  OBSERVATION = 'observacoes_',
}
